import React, { Dispatch, SetStateAction, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import { TypePages, TypePoints } from ".";
import Button from "../../../../components/Button";
import { InputMobile, LabelMobile, MergeLabelAndInputMobile } from "../../../../components/Input-Mobile/InputAndLabelMobile";
import InputSelectMobile from "../../../../components/InputSelectMobile";
import { toastError, toastWarn } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { convertDate, currentDate, currentHours, _formatDate } from "../../../../libs/dateUtils";
import { savePoints } from "../../service";
import { TitleMobile } from "../components/TitleMobile";
import "./index.scss";

export function ConfirmRegister({
  setPages,
  points,
  oldPoints,
  setOldPoints,
  setPoints,
  getAllPointsThisDate,
}: {
  setPages: Dispatch<SetStateAction<TypePages>>;
  points: TypePoints;
  oldPoints: TypePoints[];
  setOldPoints: Dispatch<SetStateAction<TypePoints[]>>;
  setPoints: Dispatch<SetStateAction<TypePoints>>;
  getAllPointsThisDate: (clientId, date, dateReceivedOfChild?: boolean) => void;
}) {
  const { userId, token } = useAuthData();
  const [valuePoint, setValuePoint] = useState(currentHours());
  const [date, setDate] = useState(points?.date);

  function validPoint() {
    // if (!oldPoints) return false;
    if (points?.entrance && points?.entrance > valuePoint) return { status: true, message: "Saída maior que Entrada" };
    if (oldPoints?.length > 1 && oldPoints[oldPoints?.length - 1]?.exit > valuePoint)
      return { status: true, message: "Última saída maior que esta entrada" };
    return { status: false, message: "" };
  }

  const handleClick = async () => {
    if (validPoint().status) return toastError(validPoint().message);
    const newPoints = oldPoints
      ? {
          userId,
          date,
          points: [
            ...oldPoints,
            {
              ...points,
              date,
              [`${!points?.entrance ? "entrance" : "exit"}`]: valuePoint,
            },
          ],
        }
      : {
          userId,
          date,
          points: [
            {
              ...points,
              date,
              [`${!points?.entrance ? "entrance" : "exit"}`]: valuePoint,
            },
          ],
        };
    // setPoints({
    //   ...points,
    //   [`${!points?.entrance ? "entrance" : "exit"}`]: valuePoint,
    // });
    const dataPoint = await savePoints(newPoints, token);
    if (dataPoint.ok) return setPages("registered");
    return toastError("Error ao registrar");
  };

  function errorData() {
    toastWarn(`O ponto ${!points?.entrance ? "entrada" : "saída"} não foi registrado`);
  }

  return (
    <>
      <Toaster />
      <TitleMobile returnClick={points?.entrance ? false : true} onClick={() => setPages("select")} title="Apontamento de Horas" />
      <div className="w-screen h-4/6 flex-col bg-primary -ml-8 p-8  flex items-center shadow">
        <div className="w-4/5 h-full flex flex-col items-center justify-evenly">
          {!points?.entrance ? (
            <MergeLabelAndInputMobile>
              <LabelMobile children="Data" className="label-input-mobile" />
              <InputMobile
                className="input-date-chosen-register bg-primary border border-white w-full"
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                onBlur={(e) => {
                  setPoints(null);
                  setOldPoints(null);
                  getAllPointsThisDate(undefined, e.target.value?.replaceAll("-", "/"), true);
                }}
              />
            </MergeLabelAndInputMobile>
          ) : (
            <p className="text-5xl text-white text-center font-familyPoppins border-b-2 border-white">{convertDate(date)}</p>
          )}
          <MergeLabelAndInputMobile className="flex flex-col">
            <LabelMobile children="Hora" className="label-input-mobile" />
            <InputMobile
              className="group-hover:flex justify-start input-hours-chosen bg-primary text-4xl w-full"
              type="time"
              value={valuePoint}
              onChange={(e) => setValuePoint(e.target.value)}
            />
          </MergeLabelAndInputMobile>
          <p className="label-input-mobile px-5 border-b-2 shadow-2xl">{!points?.entrance ? "Entrada" : "Saída"}</p>
        </div>
      </div>

      <div className="w-full h-1/6 flex justify-center items-center">
        {valuePoint ? (
          <button
            className="bg-primary h-20 rounded-2xl w-full mx-3 text-2rem font-familyPoppins font-medium shadow-2xl"
            onClick={() => handleClick()}
          >
            Registrar
          </button>
        ) : (
          <Button
            className="bg-blue-200 h-20 rounded-2xl w-full mx-3 text-4xl text-primary font-familyPoppins font-medium shadow-2xl cursor-not-allowed"
            onClick={() => errorData()}
          >
            Registrar
          </Button>
        )}
      </div>
    </>
  );
}
